import { TraceEventName } from "../enums/trace-events.enum";
import { IEventDescriptor } from "../interfaces/trace.interface";


export class VisitEvent implements IEventDescriptor {
  readonly eventType = 'VISIT';
  eventName: TraceEventName;

  constructor(eventName: TraceEventName) {
    this.eventName = eventName;
  }
}
